import { Component, Renderer2 } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from '../ag-grid.service';
import { ToastrService } from 'ngx-toastr';
import { SendNotification } from '../ag-grid.model';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonPopupComponent } from 'src/app/shared/common-popup/common-popup.component';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-common-icons',
  templateUrl: './common-icons.component.html',
  styleUrls: ['./common-icons.component.scss']
})
export class CommonIconsComponent extends CommonService implements ICellRendererAngularComp {
  params: any = {};
  sendNotifications = new SendNotification();
  constructor(
    public agGridService: AgGridService,
    public toaster: ToastrService,
    private modalService: NgbModal,
    private rendere: Renderer2,
  ) {
    super(rendere)
  }


  agInit(params: ICellRendererParams | any): void {
    this.params = params;

  }
  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  //WhatsApp Data //

  openConfirmationPopup(params:any): void {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      size: "sm",
    };
    const modalRef = this.modalService.open(CommonPopupComponent, modalOption);
    modalRef.componentInstance.sendToMailOrWhatsapp = 'whatsApp';
    modalRef.result.then((res) => {
      if (res) {
        this.clickOnWhatsapp(params)
      }
    })
  }

  clickOnWhatsapp(params:any) {
    console.log(params);
    const selectedData = { data: [params?.data?.id], notificationTypeId: 2 };
    this.sendNotification(selectedData)

  }

  sendNotification(selectedData:any) {
    if (this.params.data.contactNo !== '') {
      this.sendNotifications.notificationTypeId = selectedData.notificationTypeId;
      this.sendNotifications.id = selectedData.data;
      this.agGridService.sendNotification(this.sendNotifications).subscribe(res => {
        console.log(res);
        if (res.isSuccess) {
          this.toaster.success(res.message)
        } else {
          this.toaster.error(res.message)

        }
      })
    } else {
      this.toaster.error("Whatsapp is empty.")
    }
  }
  //WhatsApp Data //

  //PDF Data  //

  handlePrintClick(params:any): void {
    const customEvent = new CustomEvent('printButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(customEvent);
  }

  clickOnPdfIcon(params:any) {
    console.log(params);
    const selectedData = { data: [params?.data?.id], notificationTypeId: 3 };
    this.sendNootification(selectedData)
  }

  sendNootification(selectedData:any) {
    if (this.params.data.contactNo !== '') {
      this.sendNotifications.notificationTypeId = selectedData.notificationTypeId;
      this.sendNotifications.id = selectedData.data;
      this.agGridService.sendNotification(this.sendNotifications).subscribe(res => {
        console.log(res);
        if (res.isSuccess) {
          this.base64ToPdfAndPrint(res.response)
        } else {
          this.toaster.error(res.message)

        }
      })
    } else {
      this.toaster.error("PDF not available")
    }
  }

  handlePrinttClick(params:any): void {
    const customEvent = new CustomEvent('printButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(customEvent);
  }
  clickOnEmail(params:any) {
    const selectedData = { data: [params?.data?.id], notificationTypeId: 1 };
    this.seendNotification(selectedData)
  }

  seendNotification(selectedData:any) {
    if (this.params.data.email !== '') {
      this.sendNotifications.notificationTypeId = selectedData.notificationTypeId;
      this.sendNotifications.id = selectedData.data;
      this.agGridService.sendNotification(this.sendNotifications).subscribe(res => {
        console.log(res);
        if (res.isSuccess) {
          this.toaster.success(res.message)
        } else {
          this.toaster.error(res.message)

        }
      })
    } else {
      this.toaster.error("Mail is empty.")
    }
  }

  opeenConfirmationPopup(params:any): void {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      size: "sm",
    };
    const modalRef = this.modalService.open(CommonPopupComponent, modalOption);
    modalRef.componentInstance.sendToMailOrWhatsapp = 'email';
    modalRef.result.then((res) => {
      if (res) {
        this.clickOnEmail(params)
      }
    })
  }
}